import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ShiftReport from "@/components/ShiftReport";
import PrintButtons from "@/components/PrintButtons";

export default function ReportDialog({ report, onClose, title = "Shift report" }) {
  return (
    <Dialog open={!!report} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto rounded-3xl sm:max-w-4xl" data-testid="report-dialog">
        <DialogHeader><DialogTitle className="font-display">{title}</DialogTitle></DialogHeader>
        {report && (
          <>
            <PrintButtons testPrefix="report-print">{(f) => <ShiftReport report={report} format={f} />}</PrintButtons>
            <div className="overflow-x-auto rounded-2xl border border-slate-200 p-5"><ShiftReport report={report} /></div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
